var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VideoPlayer',{attrs:{"role":_vm.role,"video":"https://firebasestorage.googleapis.com/v0/b/lobby-game.appspot.com/o/start-video-sinterklaas.mp4?alt=media&token=121d5c6c-94bf-4679-924d-a9369f9e6478"}})}
var staticRenderFns = []

export { render, staticRenderFns }